// Data Source fields
export const DATA_SOURCE_NAME_FIELD = 'dataSource.name';
export const DATA_SOURCE_VENDOR_FIELD = 'dataSource.vendor';
export const DATA_SOURCE_CATEGORY_FIELD = 'dataSource.category';

// Event fields
export const EVENT_CATEGORY_FIELD = 'event.category';
export const EVENT_DETAILS_FIELD = 'event.details';
export const EVENT_SOURCE_FIELD = 'event.source';
export const EVENT_TARGET_FIELD = 'event.target';
export const EVENT_TIME_FIELD = 'event.time';
export const EVENT_TYPE_FIELD = 'event.type';
export const SEVERITY_FIELD = 'severity';
export const TIMESTAMP_FIELD = 'timestamp';
